const axios   = require('axios').default;
const Cookies = require('js-cookie');
const bsCustomFileInput = require("bs-custom-file-input");

class User {

  constructor() {
  }

  get_axios_instance(){
    var csfr_token  = $('meta[name="csrf-token"]').attr('content');
    return axios.create({
      baseURL: '/api/v1',
      timeout: 5000,
      headers: {'X-CSRF-Token': csfr_token }
    });
  }

  login(email, password, cb){

    var self = this;

    this.get_axios_instance().post('/users/login', {"email":email,"password":password})
    .then(function (response) {
      self.set_profile(response.data.profile, function(){
        return cb(response.status);
      });
    })
    .catch(function (error) {
      return cb(error.response.status, error.response.data);
    });

  }

  logout(cb){

    this.get_axios_instance().post('/users/logout')
    .then(function (response) {
      Cookies.remove('_choiz_profile');
      return cb(true);
    })
    .catch(function (error) {
      return cb(false);
    });

  }

  create_user(nickname, email, password, sdgs, cb){
    var self = this;

    this.get_axios_instance().post('/users', {"nickname":nickname,"email":email,"password":password,"sdgs":sdgs})
    .then(function (response) {
      self.set_profile(response.data.profile, function(){
        return cb(response.status);
      });
    })
    .catch(function (error) {
      return cb(error.response.status, error.response.data);
    });

  }

  update_user(nickname, email, password, cb){
    var self = this;

    this.get_axios_instance().put('/users/me', {"nickname":nickname,"email":email,"password":password})
    .then(function (response) {
      self.set_profile(response.data.profile, function(){
        return cb(response.status);
      });
    })
    .catch(function (error) {
      return cb(error.response.status, error.response.data);
    });

  }

  set_sdgs(sdgs, cb){
    var self = this;

    this.get_axios_instance().put('/users/me/sdgs', {"sdgs":sdgs})
    .then(function (response) {
      self.set_profile(response.data.profile, function(){
        return cb(response.status);
      });
    })
    .catch(function (error) {
      return cb(error.response.status, error.response.data);
    });

  }

  get_sdgs(cb){
    this.get_profile(function(current_profile){
      if (current_profile && current_profile.sdgs){
        return cb(current_profile.sdgs);
      }
      else {
        return cb([]);
      }
    });
  }

  get_user(cb){

    this.get_axios_instance().get('/users/me')
    .then(function (response) {
      return cb(response.status, response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, error.response.data);
    });

  }

  get_profile(cb){
    try{
      var current_profile = JSON.parse(Cookies.get('_choiz_profile'));
    }
    catch(error){
      var current_profile = {};
    }
    return cb(current_profile);
  }

  set_profile(profile, cb){
    Cookies.set('_choiz_profile', JSON.stringify(profile), { expires: 365, secure: (location.protocol == "http:" ? false : true), sameSite: 'strict' });
    return cb(profile);
  }

  is_logged_in(cb){
    this.get_profile(function(current_profile){
      if (current_profile && current_profile.nickname){
        return cb(true);
      }
      else {
        return cb(false);
      }
    });
  }

  forgot_password(email, cb){
    this.get_axios_instance().post('/users/forgot_password', {"email":email})
    .then(function (response) {
      return cb(response.status);
    })
    .catch(function (error) {
      return cb(error.response.status, error.response.data);
    });
  }

}

window.User = User;

showUploadForm = function() {
	jquery('#campaign-upload-form').show();
}

$(document).ready(function(){
	bsCustomFileInput.init();

  // user new password form submit
  $('#user-newpassword-submit').on('click', function(e){
    e.preventDefault();
    $('#user-newpassword-messagebox').hide();

    var user      = new User();
    var email     = $('#user-newpassword-email-input')[0].value;

    if (! email || email.length < 8){ return; }

    user.forgot_password(email, function(status, message){

      if (status == 200){
        $('#user-newpassword-messagebox').text('Wenn die angegebene Adresse korrekt war, wirst Du in Kürze eine E-Mail erhalten.');
        $('#user-newpassword-messagebox').show();

        $('#user-newpassword-submit').text("Weiter zum Login");
        $('#user-newpassword-submit').off('click').on('click', function(){
          window.location.href = '/slug/user_login';
        });

      }
      else {
        // show error-message
        $('#user-newpassword-messagebox').text(message);
        $('#user-newpassword-messagebox').show();
      }

    });
    return false;
  });

  // user login form submit
  $('#user-login-submit').on('click', function(e){
    e.preventDefault();
    $('#user-login-messagebox').hide();

    var user      = new User();
    var email     = $('#user-login-email-input')[0].value;
    var password  = $('#user-login-password-input')[0].value;

    user.login(email, password, function(status, message){

      if (status == 200){
        window.location.href = '/home';
      }
      else {
        // show error-message
        $('#user-login-messagebox').show();
      }

    });
    return false;
  });

  // user register form submit
  $('#user-register-submit').on('click', function(e){
    e.preventDefault();
    $('#user-register-messagebox').text("");
    $('#user-register-messagebox').hide();

    var user      = new User();

    var nickname  = $('#user-register-nickname-input')[0].value;
    var email     = $('#user-register-email-input')[0].value;
    var password  = $('#user-register-password-input')[0].value;
    var password_again      = $('#user-register-password-again-input')[0].value;
    var datenschutz_checked = $('#user-register-datenschutz')[0].checked;
    var agb_checked         = $('#user-register-agb')[0].checked;

    if (password != password_again){
       $('#user-register-messagebox').text("Die Passwörter stimmen nicht überein");
       $('#user-register-messagebox').show();
       return false;
    }

    if (! datenschutz_checked){
       $('#user-register-messagebox').text("Bitte akzeptiere die Datenschutzerklärung");
       $('#user-register-messagebox').show();
       return false;
    }

    if (! agb_checked){
       $('#user-register-messagebox').text("Bitte akzeptiere die AGB");
       $('#user-register-messagebox').show();
       return false;
    }

    user.get_sdgs(function(sdgs){

      user.create_user(nickname, email, password, sdgs, function(status, message){

        if (status == 200){
          window.location.href = '/home';
        }
        else {
          // show error-message
          $('#user-register-messagebox').text(message);
          $('#user-register-messagebox').show();
        }

      });

    });

    return false;
  });

  // user profile form submit
  $('#user-profile-submit').on('click', function(e){
    e.preventDefault();
    $('#user-profile-messagebox').text("");
    $('#user-profile-messagebox').hide();

    var user      = new User();

    var nickname  = $('#user-profile-nickname-input')[0].value;
    var email     = $('#user-profile-email-input')[0].value;
    var password  = $('#user-profile-password-input')[0].value;
    var password_again      = $('#user-profile-password-again-input')[0].value;

    if (password && password != password_again){
       $('#user-profile-messagebox').text("Die Passwörter stimmen nicht überein");
       $('#user-profile-messagebox').show();
       return false;
    }

    user.update_user(nickname, email, password, function(status, message){

      if (status == 200){
        window.location.href = '/home';
      }
      else {
        // show error-message
        $('#user-profile-messagebox').text(message);
        $('#user-profile-messagebox').show();
      }

    });

    return false;
  });

});
